/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  bus
} from '../../main';
import {
  mapGetters,
  mapState
} from 'vuex';
import axios from 'axios';
import root from '../../_helpers/roots';
export default {
  name: 'note-edit',
  components: {},
  props: ['courseId', 'noteId'],
  data() {
    return {
      name: '',
      description: '',
      submitted: false,
      uploadFileName: '',
      uploadingLoader: false,
    }
  },
  computed: {
  },
  mounted() {
    console.log(this.$route.params.id, "Test")
    this.getCourseNotesDetails()
  },
  methods: {
    getCourseNotesDetails: function() {
      $('.courseloader').show();
      let notesListLink = root.notesListingLink.link + '/' + this.noteId;
      axios.get(notesListLink).then(response => {
        if (response.status === 200) {
          this.name = response.data.data.name;
          this.description = response.data.data.description;
          $('.courseloader').hide();
        }
      }).catch(err => {
        console.error(err);
        $('.courseloader').hide();
      })
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.uploadingLoader = true
          let formData = new FormData();
          formData.append('course', this.courseId);
          formData.append('name', this.name);
          formData.append('description', this.description);
          $('.courseloader').show();
          let notesListLink = root.notesListLink.link + this.noteId + '/';
          axios.patch(notesListLink, formData).then(response => {
            if (response.status === 200) {
              toast.success(response.data.msg);
              this.$validator.reset();
              $('.courseloader').hide();
              bus.$emit('HideEditNotePopup', {
                status: false,
                reload: true
              })
            }
          }).catch(err => {
            console.error(err);
            $('.courseloader').hide();
            this.popupCloseFun()
          })
          return
        }
      });
    },
    popupCloseFun() {
      bus.$emit('HideEditNotePopup', {
        status: false,
        reload: false
      })
    },
    resetFileBefore() {
      this.uploadFileName = '';
      this.$validator.reset();
    }
  }
}